// TODO: simplify when module namespaced
export const PRODUCT_MULTIPLE_TRANSITION_PROCESS_CLEAR_STATE = "clearProductMultipleTransitionProcess";

// TODO: simplify when module namespaced
export const PRODUCT_MULTIPLE_TRANSITION_PROCESS_CLEAR_ACTION = "clearProductMultipleTransitionProcessAction";

export const ProductMultipleTransitionProcessStoreActions = {
	CLEAR: `${PRODUCT_MULTIPLE_TRANSITION_PROCESS_CLEAR_ACTION}`
} as const;
